export const dataToEntity = (data) => ({
  accessKey: data.accessKey,
  secretKey: data.secretKey,
})
